<div class="blur-content" *ngIf="Page!=='landingpage'">
  <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>
  <div class="row">
    <div class="custom-datatable col-lg-12 col-md-12 col-sm-12">
      <div [ngClass]="{'datatable-scroll-common': true}">
        <ngx-datatable class="bootstrap" [rows]="dummyListToShow" [columnMode]="'force'" [headerHeight]="40"
          [footerHeight]="50" rowHeight="auto" [selectAllRowsOnPage]="false" [externalPaging]="false"
          [scrollbarH]="true" [limit]="10">
          <ngx-datatable-column name="Business Name" prop="businessName">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.businessName }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Owner" prop="businessOwner"></ngx-datatable-column>
          <ngx-datatable-column name="Email" prop="businessEmail"></ngx-datatable-column>
          <ngx-datatable-column name="Created Date" prop="createddate"></ngx-datatable-column>
          <ngx-datatable-column name="Last Active" prop="lastactive"></ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
<div [ngClass]="{ 'con-border': Page === 'landingpage', 'popup-container': Page !== 'landingpage' }">

  <div class="popup-content">
    <div class="popup-section">

      <div [ngClass]="{'m-lo': Page === 'landingpage'}" class="popup-logo">
        <img src="assets/icon/gigsumologo_bigface.png">
      </div>
      <div [ngClass]="{'m-l': Page !== 'landingpage'}">
        <h3>Unlock {{ header }}</h3>
        <div style="margin-top:38px">
          <p>This functionality requires subscription to</p>
          <p style="color: #8B5CF6;">Starter/ Growth / ScaleX plan.</p>
        </div>
      </div>
      <div class="popup-actions">
        <button class="btn btn-primary upgrade-btn" (click)="upgrade()">Upgrade</button>
      </div>
    </div>
    <div class="popup-section">
      <h3>Starter/ Growth / ScaleX plans</h3>
      <h3 style="margin-left:-124px">enable</h3>
      <ul class="popup-features">
        <li *ngFor="let feature of features">
          <input type="checkbox" checked disabled> {{ feature.text }}
        </li>
      </ul>

    </div>
  </div>
</div>